import { render, staticRenderFns } from "./TabAffiliateSales.vue?vue&type=template&id=cce5266c&scoped=true&"
import script from "./TabAffiliateSales.vue?vue&type=script&lang=js&"
export * from "./TabAffiliateSales.vue?vue&type=script&lang=js&"
import style0 from "./TabAffiliateSales.vue?vue&type=style&index=0&id=cce5266c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce5266c",
  null
  
)

component.options.__file = "TabAffiliateSales.vue"
export default component.exports